<template>
  <vue-flux :options="vfOptions" :images="imagesMap" :transitions="vfTransitions" ref="slider">
    <template v-slot:preloader>
      <flux-preloader :spinner="false" />
    </template>

    <template v-slot:controls>
      <flux-controls />
      <button
        type="button"
        class="flux-button lightbox bottom left"
        style="outline: 0px;"
        @click="openLightbox"
      >
        <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" version="1.1">
          <circle cx="50" cy="50" r="49"></circle>
          <svg
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="25%"
            y="25%"
            viewBox="0 0 600 600"
            style="enable-background:new 0 0 298.667 298.667;"
            xml:space="preserve"
          >
            <g>
              <g>
                <g>
                  <polygon points="42.667,192 0,192 0,298.667 106.667,298.667 106.667,256 42.667,256 			" />
                  <polygon points="0,106.667 42.667,106.667 42.667,42.667 106.667,42.667 106.667,0 0,0 			" />
                  <polygon points="192,0 192,42.667 256,42.667 256,106.667 298.667,106.667 298.667,0 			" />
                  <polygon points="256,256 192,256 192,298.667 298.667,298.667 298.667,192 256,192 			" />
                </g>
              </g>
            </g>
          </svg>
        </svg>
      </button>
    </template>

    <template v-slot:pagination>
      <flux-pagination />
    </template>

    <template v-slot:index>
      <flux-index />
    </template>
  </vue-flux>
</template>

<script>
import { FluxCaption, FluxControls, FluxIndex, FluxPagination, FluxPreloader, VueFlux } from 'vue-flux';
import ImageLightbox from '@components/ImageLightbox';

export default {
  name: 'ImageSlides',
  components: {
    ImageLightbox,
    VueFlux,
    FluxCaption,
    FluxControls,
    FluxIndex,
    FluxPagination,
    FluxPreloader,
  },

  props: {
    images: {
      type: Array,
      default: () => [],
    },
    lightbox: {
      required: true,
      type: Function
    }
  },

  computed: {
    imagesMap: function() {
      return this.images.map(i => i.url);
    },
  },

  methods: {
    openLightbox() {
      this.lightbox(this.$refs.slider.Images.current.index);
    },
  },

  data: () => ({
    vfOptions: {
      autoplay: true,
      autohideTime: 2500,
      delay: 2500,
    },
    vfTransitions: ['fade'],
  }),
};
</script>

<style lang="scss">
.vue-flux {
  border-radius: 15px;
  .flux-transition {
    border-radius: 15px !important;
  }

  .flux-image {
    border-radius: 15px !important;
  }
}

.lightbox {
  position: absolute;
  left: 8%;
  top: 4%;
  transform: translateX(-50%);
}
</style>
